export class AddAdditionalEmailSuccess {
    static readonly type = '[User] AddAdditionalEmailSuccess';
}
